import { CommonModule } from '@angular/common';
import { Component, output, input, inject } from '@angular/core';

import type { IStatisticsConfig } from '../../interfaces/statistics-config.interface';
import { AuthService } from '../../../core/auth/services/auth.service';
import { UserRole } from '../../../core/auth/enums/userRoles';

@Component({
  selector: 'app-statistics',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
})
export class StatisticsComponent {
  private readonly authService = inject(AuthService);

  // Core Properties
  public readonly type = input<string>(); // => "info" | "warning" | "success" | "error" | "secondary" | "default";
  public readonly title = input<string>('');
  public readonly value = input<string>('');
  public readonly maxWidth = input<number>();

  // Styling Properties
  public readonly customClasses = input<string | string[]>([]);
  public readonly config = input<IStatisticsConfig | null>(null);
  appSetting = this.authService.appSetting();
  hasStatusFilter = this.appSetting['hasStatusFilterPermission'];
  statClick = output<string>();
  isClient: boolean = localStorage.getItem('role')?.toLowerCase() === UserRole.Client;
}
